import './styles.scoped.css'
import {useState, useEffect, useRef} from 'react'
import {Avatar, Typography, Button, InputAdornment, Modal, TextField, IconButton} from '@mui/material'
import {Close, Search, Email, Phone, CheckCircle} from '@mui/icons-material'
import {dashboardApi} from '../../../../services'
import {useGlobalStates} from '../../../../contexts/GlobalStatesContext'
import {useMobile} from '../../../../hooks'
import {DrilldownCardsSkeleton} from '../DashboardSkeletons'
import {parseError, getColorFromName, getInitials, ignoreTimezone} from '../../../../utils/helpers'
import {format} from 'date-fns'
import {useNavigate} from 'react-router-dom'

export default ({open, setOpen}) => {
    const {mobile} = useMobile()
    const [items, setItems] = useState([])
    const [filteredItems, setFilteredItems] = useState([])
    const [searchQuery, setSearchQuery] = useState('')
    const [skeleton, setSkeleton] = useState(true)
    const requestId = useRef(0)
    const {setMessageBox, branchId} = useGlobalStates()
    const navigate = useNavigate()

    useEffect(() => {
        if (open) {
            loadData()
        }
    }, [open, branchId])

    useEffect(() => {
        if (items && searchQuery) {
            setFilteredItems(items.filter(item => item?.name?.toLowerCase().includes(searchQuery.toLowerCase())))
        } else {
            setFilteredItems(items)
        }
    }, [searchQuery, items])

    const loadData = () => {
        const id = ++requestId.current
        setItems([])
        setFilteredItems([])
        setSkeleton(true)
        dashboardApi
            .getClients(branchId, {page_size: 100, category: 'new'})
            .then(
                ({
                    data: {
                        data: {items: data},
                    },
                }) => {
                    if (id !== requestId.current) return
                    setItems(data || [])
                    setSkeleton(false)
                },
            )
            .catch(error => {
                if (id !== requestId.current) return
                setSkeleton(false)
                const {title, description} = parseError(error)
                if (description) {
                    setMessageBox({status: 'error', title, description})
                }
            })
    }

    const action = item => {
        navigate(`/clients-management/${item?.id}/personal-information`)
    }

    return (
        <Modal open={open}>
            <div className="container">
                <div className="content">
                    <div className="header">
                        <Typography variant="h6" color="text.primary">
                            New Clients
                        </Typography>
                        <div className="form">
                            <div className="view-more" onClick={() => navigate('/clients-management')}>
                                <Typography variant="h8" color="primary">
                                    View More
                                </Typography>
                            </div>
                            <IconButton onClick={() => setOpen(false)}>
                                <Close />
                            </IconButton>
                        </div>
                    </div>
                    <br />
                    {mobile && (
                        <>
                            <br />
                            <br />
                            <br />
                            <br />
                        </>
                    )}
                    <TextField
                        placeholder="Search client ..."
                        fullWidth
                        onChange={e => setSearchQuery(e.target.value)}
                        slotProps={{
                            input: {
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Search />
                                    </InputAdornment>
                                ),
                            },
                        }}
                    />
                    <br />
                    {skeleton && (
                        <DrilldownCardsSkeleton
                            rows={[{person: 40, nameFontSize: 16, contact: true}, {text: ['72%', '56%', '64%', '48%']}, {eligibility: true}]}
                        />
                    )}
                    {filteredItems.map((item, index) => (
                        <div key={index}>
                            <br />
                            <div className="card" onClick={() => action(item)}>
                                <div className="people-card">
                                    {item?.avatar_url ? (
                                        <Avatar src={item?.avatar_url} style={{width: 40, height: 40}} />
                                    ) : (
                                        <Avatar
                                            style={{
                                                backgroundColor: getColorFromName(item?.name),
                                                width: 40,
                                                height: 40,
                                                fontSize: 20,
                                            }}>
                                            {getInitials(item?.name)}
                                        </Avatar>
                                    )}
                                    <div className="people-profile-card">
                                        <Typography variant="h8" color="primary">
                                            {item?.name}
                                        </Typography>
                                        <div className="form">
                                            <Email fontSize="small" style={{color: '#073735'}} />
                                            <Typography variant="body3" color="text.secondary">
                                                {item?.email}
                                            </Typography>
                                            <Typography variant="body3" color="text.secondary">
                                                |
                                            </Typography>
                                            <Phone fontSize="small" style={{color: '#073735'}} />
                                            <Typography variant="body3" color="text.secondary">
                                                {item?.phone}
                                            </Typography>
                                        </div>
                                    </div>
                                </div>
                                <div className="form2">
                                    <Typography variant="body2" color="text.primary">
                                        <b>Services:</b>
                                    </Typography>
                                    <Typography variant="body2" color="text.primary">
                                        {item?.services?.length > 3 ? (
                                            <>
                                                {item?.services?.slice(0, 3).join(', ')}, <b>+{item?.services?.length - 3} more</b>
                                            </>
                                        ) : (
                                            item?.services?.join(', ')
                                        )}
                                    </Typography>
                                </div>
                                <div className="form">
                                    <Typography variant="body2" color="text.primary">
                                        <b>Eligibility:</b>
                                    </Typography>
                                    <CheckCircle fontSize="medium" color="success" />
                                    <Typography variant="body2" color="text.primary">
                                        (last checked: {format(new Date(ignoreTimezone(item?.last_checked)), 'dd MMM yyyy')})
                                    </Typography>
                                </div>
                            </div>
                        </div>
                    ))}
                    <br />
                    <br />
                    {mobile && (
                        <>
                            <br />
                            <br />
                            <br />
                            <br />
                        </>
                    )}
                </div>
            </div>
        </Modal>
    )
}
